export default __webpack_public_path__ + "static/media/foiegras_thumb.a7207013.jpg";